(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fitorb-be-nl-content"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    if (event.defaultPrevented) return;
    const opener = event.target.closest('[data-fpdf-benefits-open]');
    const closer = event.target.closest('[data-fpdf-benefits-close]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.fpdfBenefitsOpen);
      if (!dialog) return;
      event.preventDefault();
      dialog.addEventListener('close', () => opener.focus({preventScroll:true}), {once:true});
      dialog.showModal();
    } else if (closer) {
      event.preventDefault();
      closer.closest('dialog').close();
    } else if (event.target.matches('dialog.fpdf__dialog--benefits')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  document.addEventListener('click', function(event) {
    const trigger = event.target.closest('[data-fpdf-video-open]');
    if (!trigger || event.defaultPrevented) return;
    event.preventDefault();
    const preview = trigger.closest('figure').querySelector('video');
    if (!preview) return;
    const dialog = document.createElement('dialog');
    dialog.className = 'fpdf-c__video-dialog';
    const close = document.createElement('button');
    close.type = 'button'; close.textContent = '×'; close.setAttribute('aria-label', 'Sluiten');
    const player = preview.cloneNode(true);
    player.controls = true; player.muted = false; player.removeAttribute('muted'); player.loop = false;
    dialog.append(close, player); document.body.append(dialog);
    preview.pause(); dialog.showModal(); player.play().catch(() => {});
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => { if(e.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => {player.pause(); dialog.remove(); preview.play().catch(() => {}); trigger.focus();}, {once:true});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fitorb-be-pdf-content"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    if (event.defaultPrevented) return;
    const opener = event.target.closest('[data-fpdf-benefits-open]');
    const closer = event.target.closest('[data-fpdf-benefits-close]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.fpdfBenefitsOpen);
      if (!dialog) return;
      event.preventDefault();
      dialog.addEventListener('close', () => opener.focus({preventScroll:true}), {once:true});
      dialog.showModal();
    } else if (closer) {
      event.preventDefault();
      closer.closest('dialog').close();
    } else if (event.target.matches('dialog.fpdf__dialog--benefits')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  document.addEventListener('click', function(event) {
    const trigger = event.target.closest('[data-fpdf-video-open]');
    if (!trigger || event.defaultPrevented) return;
    event.preventDefault();
    const preview = trigger.closest('figure').querySelector('video');
    if (!preview) return;
    const dialog = document.createElement('dialog');
    dialog.className = 'fpdf-c__video-dialog';
    const close = document.createElement('button');
    close.type = 'button'; close.textContent = '×'; close.setAttribute('aria-label', 'Schließen');
    const player = preview.cloneNode(true);
    player.controls = true; player.muted = false; player.removeAttribute('muted'); player.loop = false;
    dialog.append(close, player); document.body.append(dialog);
    preview.pause(); dialog.showModal(); player.play().catch(() => {});
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => { if(e.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => {player.pause(); dialog.remove(); preview.play().catch(() => {}); trigger.focus();}, {once:true});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fitorb-cs-content"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    if (event.defaultPrevented) return;
    const opener = event.target.closest('[data-fpdf-benefits-open]');
    const closer = event.target.closest('[data-fpdf-benefits-close]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.fpdfBenefitsOpen);
      if (!dialog) return;
      event.preventDefault();
      dialog.addEventListener('close', () => opener.focus({preventScroll:true}), {once:true});
      dialog.showModal();
    } else if (closer) {
      event.preventDefault();
      closer.closest('dialog').close();
    } else if (event.target.matches('dialog.fpdf__dialog--benefits')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  document.addEventListener('click', function(event) {
    const trigger = event.target.closest('[data-fpdf-video-open]');
    if (!trigger || event.defaultPrevented) return;
    event.preventDefault();
    const preview = trigger.closest('figure').querySelector('video');
    if (!preview) return;
    const dialog = document.createElement('dialog');
    dialog.className = 'fpdf-c__video-dialog';
    const close = document.createElement('button');
    close.type = 'button'; close.textContent = '×'; close.setAttribute('aria-label', 'Zavřít');
    const player = preview.cloneNode(true);
    player.controls = true; player.muted = false; player.removeAttribute('muted'); player.loop = false;
    dialog.append(close, player); document.body.append(dialog);
    preview.pause(); dialog.showModal(); player.play().catch(() => {});
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => { if(e.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => {player.pause(); dialog.remove(); preview.play().catch(() => {}); trigger.focus();}, {once:true});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fitorb-da-content"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    if (event.defaultPrevented) return;
    const opener = event.target.closest('[data-fpdf-benefits-open]');
    const closer = event.target.closest('[data-fpdf-benefits-close]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.fpdfBenefitsOpen);
      if (!dialog) return;
      event.preventDefault();
      dialog.addEventListener('close', () => opener.focus({preventScroll:true}), {once:true});
      dialog.showModal();
    } else if (closer) {
      event.preventDefault();
      closer.closest('dialog').close();
    } else if (event.target.matches('dialog.fpdf__dialog--benefits')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  document.addEventListener('click', function(event) {
    const trigger = event.target.closest('[data-fpdf-video-open]');
    if (!trigger || event.defaultPrevented) return;
    event.preventDefault();
    const preview = trigger.closest('figure').querySelector('video');
    if (!preview) return;
    const dialog = document.createElement('dialog');
    dialog.className = 'fpdf-c__video-dialog';
    const close = document.createElement('button');
    close.type = 'button'; close.textContent = '×'; close.setAttribute('aria-label', 'Luk');
    const player = preview.cloneNode(true);
    player.controls = true; player.muted = false; player.removeAttribute('muted'); player.loop = false;
    dialog.append(close, player); document.body.append(dialog);
    preview.pause(); dialog.showModal(); player.play().catch(() => {});
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => { if(e.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => {player.pause(); dialog.remove(); preview.play().catch(() => {}); trigger.focus();}, {once:true});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fitorb-es-content"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    if (event.defaultPrevented) return;
    const opener = event.target.closest('[data-fpdf-benefits-open]');
    const closer = event.target.closest('[data-fpdf-benefits-close]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.fpdfBenefitsOpen);
      if (!dialog) return;
      event.preventDefault();
      dialog.addEventListener('close', () => opener.focus({preventScroll:true}), {once:true});
      dialog.showModal();
    } else if (closer) {
      event.preventDefault();
      closer.closest('dialog').close();
    } else if (event.target.matches('dialog.fpdf__dialog--benefits')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  document.addEventListener('click', function(event) {
    const trigger = event.target.closest('[data-fpdf-video-open]');
    if (!trigger || event.defaultPrevented) return;
    event.preventDefault();
    const preview = trigger.closest('figure').querySelector('video');
    if (!preview) return;
    const dialog = document.createElement('dialog');
    dialog.className = 'fpdf-c__video-dialog';
    const close = document.createElement('button');
    close.type = 'button'; close.textContent = '×'; close.setAttribute('aria-label', 'Cerrar');
    const player = preview.cloneNode(true);
    player.controls = true; player.muted = false; player.removeAttribute('muted'); player.loop = false;
    dialog.append(close, player); document.body.append(dialog);
    preview.pause(); dialog.showModal(); player.play().catch(() => {});
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => { if(e.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => {player.pause(); dialog.remove(); preview.play().catch(() => {}); trigger.focus();}, {once:true});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fitorb-fi-content"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    if (event.defaultPrevented) return;
    const opener = event.target.closest('[data-fpdf-benefits-open]');
    const closer = event.target.closest('[data-fpdf-benefits-close]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.fpdfBenefitsOpen);
      if (!dialog) return;
      event.preventDefault();
      dialog.addEventListener('close', () => opener.focus({preventScroll:true}), {once:true});
      dialog.showModal();
    } else if (closer) {
      event.preventDefault();
      closer.closest('dialog').close();
    } else if (event.target.matches('dialog.fpdf__dialog--benefits')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  document.addEventListener('click', function(event) {
    const trigger = event.target.closest('[data-fpdf-video-open]');
    if (!trigger || event.defaultPrevented) return;
    event.preventDefault();
    const preview = trigger.closest('figure').querySelector('video');
    if (!preview) return;
    const dialog = document.createElement('dialog');
    dialog.className = 'fpdf-c__video-dialog';
    const close = document.createElement('button');
    close.type = 'button'; close.textContent = '×'; close.setAttribute('aria-label', 'Sulje');
    const player = preview.cloneNode(true);
    player.controls = true; player.muted = false; player.removeAttribute('muted'); player.loop = false;
    dialog.append(close, player); document.body.append(dialog);
    preview.pause(); dialog.showModal(); player.play().catch(() => {});
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => { if(e.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => {player.pause(); dialog.remove(); preview.play().catch(() => {}); trigger.focus();}, {once:true});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fitorb-fr-content"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    if (event.defaultPrevented) return;
    const opener = event.target.closest('[data-fpdf-benefits-open]');
    const closer = event.target.closest('[data-fpdf-benefits-close]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.fpdfBenefitsOpen);
      if (!dialog) return;
      event.preventDefault();
      dialog.addEventListener('close', () => opener.focus({preventScroll:true}), {once:true});
      dialog.showModal();
    } else if (closer) {
      event.preventDefault();
      closer.closest('dialog').close();
    } else if (event.target.matches('dialog.fpdf__dialog--benefits')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  document.addEventListener('click', function(event) {
    const trigger = event.target.closest('[data-fpdf-video-open]');
    if (!trigger || event.defaultPrevented) return;
    event.preventDefault();
    const preview = trigger.closest('figure').querySelector('video');
    if (!preview) return;
    const dialog = document.createElement('dialog');
    dialog.className = 'fpdf-c__video-dialog';
    const close = document.createElement('button');
    close.type = 'button'; close.textContent = '×'; close.setAttribute('aria-label', 'Fermer');
    const player = preview.cloneNode(true);
    player.controls = true; player.muted = false; player.removeAttribute('muted'); player.loop = false;
    dialog.append(close, player); document.body.append(dialog);
    preview.pause(); dialog.showModal(); player.play().catch(() => {});
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => { if(e.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => {player.pause(); dialog.remove(); preview.play().catch(() => {}); trigger.focus();}, {once:true});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fitorb-ie-content"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    if (event.defaultPrevented) return;
    const opener = event.target.closest('[data-fpdf-benefits-open]');
    const closer = event.target.closest('[data-fpdf-benefits-close]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.fpdfBenefitsOpen);
      if (!dialog) return;
      event.preventDefault();
      dialog.addEventListener('close', () => opener.focus({preventScroll:true}), {once:true});
      dialog.showModal();
    } else if (closer) {
      event.preventDefault();
      closer.closest('dialog').close();
    } else if (event.target.matches('dialog.fpdf__dialog--benefits')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  document.addEventListener('click', function(event) {
    const trigger = event.target.closest('[data-fpdf-video-open]');
    if (!trigger || event.defaultPrevented) return;
    event.preventDefault();
    const preview = trigger.closest('figure').querySelector('video');
    if (!preview) return;
    const dialog = document.createElement('dialog');
    dialog.className = 'fpdf-c__video-dialog';
    const close = document.createElement('button');
    close.type = 'button'; close.textContent = '×'; close.setAttribute('aria-label', 'Close');
    const player = preview.cloneNode(true);
    player.controls = true; player.muted = false; player.removeAttribute('muted'); player.loop = false;
    dialog.append(close, player); document.body.append(dialog);
    preview.pause(); dialog.showModal(); player.play().catch(() => {});
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => { if(e.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => {player.pause(); dialog.remove(); preview.play().catch(() => {}); trigger.focus();}, {once:true});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fitorb-it-content"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    if (event.defaultPrevented) return;
    const opener = event.target.closest('[data-fpdf-benefits-open]');
    const closer = event.target.closest('[data-fpdf-benefits-close]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.fpdfBenefitsOpen);
      if (!dialog) return;
      event.preventDefault();
      dialog.addEventListener('close', () => opener.focus({preventScroll:true}), {once:true});
      dialog.showModal();
    } else if (closer) {
      event.preventDefault();
      closer.closest('dialog').close();
    } else if (event.target.matches('dialog.fpdf__dialog--benefits')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  document.addEventListener('click', function(event) {
    const trigger = event.target.closest('[data-fpdf-video-open]');
    if (!trigger || event.defaultPrevented) return;
    event.preventDefault();
    const preview = trigger.closest('figure').querySelector('video');
    if (!preview) return;
    const dialog = document.createElement('dialog');
    dialog.className = 'fpdf-c__video-dialog';
    const close = document.createElement('button');
    close.type = 'button'; close.textContent = '×'; close.setAttribute('aria-label', 'Chiudi');
    const player = preview.cloneNode(true);
    player.controls = true; player.muted = false; player.removeAttribute('muted'); player.loop = false;
    dialog.append(close, player); document.body.append(dialog);
    preview.pause(); dialog.showModal(); player.play().catch(() => {});
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => { if(e.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => {player.pause(); dialog.remove(); preview.play().catch(() => {}); trigger.focus();}, {once:true});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fitorb-nl-content"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    if (event.defaultPrevented) return;
    const opener = event.target.closest('[data-fpdf-benefits-open]');
    const closer = event.target.closest('[data-fpdf-benefits-close]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.fpdfBenefitsOpen);
      if (!dialog) return;
      event.preventDefault();
      dialog.addEventListener('close', () => opener.focus({preventScroll:true}), {once:true});
      dialog.showModal();
    } else if (closer) {
      event.preventDefault();
      closer.closest('dialog').close();
    } else if (event.target.matches('dialog.fpdf__dialog--benefits')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  document.addEventListener('click', function(event) {
    const trigger = event.target.closest('[data-fpdf-video-open]');
    if (!trigger || event.defaultPrevented) return;
    event.preventDefault();
    const preview = trigger.closest('figure').querySelector('video');
    if (!preview) return;
    const dialog = document.createElement('dialog');
    dialog.className = 'fpdf-c__video-dialog';
    const close = document.createElement('button');
    close.type = 'button'; close.textContent = '×'; close.setAttribute('aria-label', 'Sluiten');
    const player = preview.cloneNode(true);
    player.controls = true; player.muted = false; player.removeAttribute('muted'); player.loop = false;
    dialog.append(close, player); document.body.append(dialog);
    preview.pause(); dialog.showModal(); player.play().catch(() => {});
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => { if(e.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => {player.pause(); dialog.remove(); preview.play().catch(() => {}); trigger.focus();}, {once:true});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fitorb-pdf-content"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    if (event.defaultPrevented) return;
    const opener = event.target.closest('[data-fpdf-benefits-open]');
    const closer = event.target.closest('[data-fpdf-benefits-close]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.fpdfBenefitsOpen);
      if (!dialog) return;
      event.preventDefault();
      dialog.addEventListener('close', () => opener.focus({preventScroll:true}), {once:true});
      dialog.showModal();
    } else if (closer) {
      event.preventDefault();
      closer.closest('dialog').close();
    } else if (event.target.matches('dialog.fpdf__dialog--benefits')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  document.addEventListener('click', function(event) {
    const trigger = event.target.closest('[data-fpdf-video-open]');
    if (!trigger || event.defaultPrevented) return;
    event.preventDefault();
    const preview = trigger.closest('figure').querySelector('video');
    if (!preview) return;
    const dialog = document.createElement('dialog');
    dialog.className = 'fpdf-c__video-dialog';
    const close = document.createElement('button');
    close.type = 'button'; close.textContent = '×'; close.setAttribute('aria-label', 'Schließen');
    const player = preview.cloneNode(true);
    player.controls = true; player.muted = false; player.removeAttribute('muted'); player.loop = false;
    dialog.append(close, player); document.body.append(dialog);
    preview.pause(); dialog.showModal(); player.play().catch(() => {});
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => { if(e.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => {player.pause(); dialog.remove(); preview.play().catch(() => {}); trigger.focus();}, {once:true});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fitorb-pdf-header"]) return;
  try {
    
  if (!customElements.get('fitorb-pdf-header')) {
    customElements.define('fitorb-pdf-header', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.menu = this.querySelector('details');
        this.addEventListener('click', (event) => {
          if (event.target.closest('nav a') && this.menu) this.menu.open = false;
        }, options);
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.menu?.open) {
            this.menu.open = false;
            this.menu.querySelector('summary').focus();
          }
        }, options);
        document.addEventListener('click', (event) => {
          if (this.menu?.open && !this.menu.contains(event.target)) this.menu.open = false;
        }, options);
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fitorb-pl-content"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    if (event.defaultPrevented) return;
    const opener = event.target.closest('[data-fpdf-benefits-open]');
    const closer = event.target.closest('[data-fpdf-benefits-close]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.fpdfBenefitsOpen);
      if (!dialog) return;
      event.preventDefault();
      dialog.addEventListener('close', () => opener.focus({preventScroll:true}), {once:true});
      dialog.showModal();
    } else if (closer) {
      event.preventDefault();
      closer.closest('dialog').close();
    } else if (event.target.matches('dialog.fpdf__dialog--benefits')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  document.addEventListener('click', function(event) {
    const trigger = event.target.closest('[data-fpdf-video-open]');
    if (!trigger || event.defaultPrevented) return;
    event.preventDefault();
    const preview = trigger.closest('figure').querySelector('video');
    if (!preview) return;
    const dialog = document.createElement('dialog');
    dialog.className = 'fpdf-c__video-dialog';
    const close = document.createElement('button');
    close.type = 'button'; close.textContent = '×'; close.setAttribute('aria-label', 'Zamknij');
    const player = preview.cloneNode(true);
    player.controls = true; player.muted = false; player.removeAttribute('muted'); player.loop = false;
    dialog.append(close, player); document.body.append(dialog);
    preview.pause(); dialog.showModal(); player.play().catch(() => {});
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => { if(e.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => {player.pause(); dialog.remove(); preview.play().catch(() => {}); trigger.focus();}, {once:true});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fitorb-sl-content"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    if (event.defaultPrevented) return;
    const opener = event.target.closest('[data-fpdf-benefits-open]');
    const closer = event.target.closest('[data-fpdf-benefits-close]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.fpdfBenefitsOpen);
      if (!dialog) return;
      event.preventDefault();
      dialog.addEventListener('close', () => opener.focus({preventScroll:true}), {once:true});
      dialog.showModal();
    } else if (closer) {
      event.preventDefault();
      closer.closest('dialog').close();
    } else if (event.target.matches('dialog.fpdf__dialog--benefits')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  document.addEventListener('click', function(event) {
    const trigger = event.target.closest('[data-fpdf-video-open]');
    if (!trigger || event.defaultPrevented) return;
    event.preventDefault();
    const preview = trigger.closest('figure').querySelector('video');
    if (!preview) return;
    const dialog = document.createElement('dialog');
    dialog.className = 'fpdf-c__video-dialog';
    const close = document.createElement('button');
    close.type = 'button'; close.textContent = '×'; close.setAttribute('aria-label', 'Zapri');
    const player = preview.cloneNode(true);
    player.controls = true; player.muted = false; player.removeAttribute('muted'); player.loop = false;
    dialog.append(close, player); document.body.append(dialog);
    preview.pause(); dialog.showModal(); player.play().catch(() => {});
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => { if(e.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => {player.pause(); dialog.remove(); preview.play().catch(() => {}); trigger.focus();}, {once:true});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fitorb-uk-content"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    if (event.defaultPrevented) return;
    const opener = event.target.closest('[data-fpdf-benefits-open]');
    const closer = event.target.closest('[data-fpdf-benefits-close]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.fpdfBenefitsOpen);
      if (!dialog) return;
      event.preventDefault();
      dialog.addEventListener('close', () => opener.focus({preventScroll:true}), {once:true});
      dialog.showModal();
    } else if (closer) {
      event.preventDefault();
      closer.closest('dialog').close();
    } else if (event.target.matches('dialog.fpdf__dialog--benefits')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  document.addEventListener('click', function(event) {
    const trigger = event.target.closest('[data-fpdf-video-open]');
    if (!trigger || event.defaultPrevented) return;
    event.preventDefault();
    const preview = trigger.closest('figure').querySelector('video');
    if (!preview) return;
    const dialog = document.createElement('dialog');
    dialog.className = 'fpdf-c__video-dialog';
    const close = document.createElement('button');
    close.type = 'button'; close.textContent = '×'; close.setAttribute('aria-label', 'Close');
    const player = preview.cloneNode(true);
    player.controls = true; player.muted = false; player.removeAttribute('muted'); player.loop = false;
    dialog.append(close, player); document.body.append(dialog);
    preview.pause(); dialog.showModal(); player.play().catch(() => {});
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => { if(e.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => {player.pause(); dialog.remove(); preview.play().catch(() => {}); trigger.focus();}, {once:true});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fitorb-us-content"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    if (event.defaultPrevented) return;
    const opener = event.target.closest('[data-fpdf-benefits-open]');
    const closer = event.target.closest('[data-fpdf-benefits-close]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.fpdfBenefitsOpen);
      if (!dialog) return;
      event.preventDefault();
      dialog.addEventListener('close', () => opener.focus({preventScroll:true}), {once:true});
      dialog.showModal();
    } else if (closer) {
      event.preventDefault();
      closer.closest('dialog').close();
    } else if (event.target.matches('dialog.fpdf__dialog--benefits')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  document.addEventListener('click', function(event) {
    const trigger = event.target.closest('[data-fpdf-video-open]');
    if (!trigger || event.defaultPrevented) return;
    event.preventDefault();
    const preview = trigger.closest('figure').querySelector('video');
    if (!preview) return;
    const dialog = document.createElement('dialog');
    dialog.className = 'fpdf-c__video-dialog';
    const close = document.createElement('button');
    close.type = 'button'; close.textContent = '×'; close.setAttribute('aria-label', 'Close');
    const player = preview.cloneNode(true);
    player.controls = true; player.muted = false; player.removeAttribute('muted'); player.loop = false;
    dialog.append(close, player); document.body.append(dialog);
    preview.pause(); dialog.showModal(); player.play().catch(() => {});
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => { if(e.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => {player.pause(); dialog.remove(); preview.play().catch(() => {}); trigger.focus();}, {once:true});
  });

  } catch(e) { console.error(e); }
})();
})();
